import { FlexColumn, LabeledInput } from '@gorila-shared-ui/components';
import { useRecoilState, useRecoilValue } from 'recoil';
import { REQUIRED_FIELD_TEXT } from '../../constants/app';
import {
  editInstallationClientValidState,
  editInstallationState,
  editInstallationTouchedState,
} from '../../storage/Installations';
import { EmissionClientRequest, EmissionClientRequestTouched } from '../../types/client';

export function InstallationClientForm() {
  const [form, setForm] = useRecoilState(editInstallationState);
  const [formTouched, setFormTouched] = useRecoilState(editInstallationTouchedState);
  const formValid = useRecoilValue(editInstallationClientValidState);

  const onTouched = (key: keyof EmissionClientRequestTouched) => {
    setFormTouched((prev) => ({
      ...prev,
      clientTouched: {
        ...prev.clientTouched,
        [key]: true,
      },
    }));
  };
  const onChangeInput = (value: any, field: keyof EmissionClientRequest) => {
    setForm((prev) => {
      return {
        ...prev,
        client: {
          ...prev.client,
          [field]: value || '',
        },
      };
    });
  };

  return (
    <FlexColumn>
      <LabeledInput
        label="Nombre / Empresa"
        placeholder="Ingresa el nombre ó empresa"
        value={form.client.clientName}
        onChange={(value) => {
          onChangeInput(value, 'clientName');
        }}
        onBlur={() => onTouched('clientNameTouched')}
        error={formTouched.clientTouched.clientNameTouched && !formValid.clientName && REQUIRED_FIELD_TEXT}
        required
      />
    </FlexColumn>
  );
}
